import { render, staticRenderFns } from "./addDefaultRole.vue?vue&type=template&id=246f215c&scoped=true&"
import script from "./addDefaultRole.vue?vue&type=script&lang=js&"
export * from "./addDefaultRole.vue?vue&type=script&lang=js&"
import style0 from "./addDefaultRole.vue?vue&type=style&index=0&id=246f215c&prod&lang=less&scoped=true&"
import style1 from "./addDefaultRole.vue?vue&type=style&index=1&id=246f215c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246f215c",
  null
  
)

export default component.exports